module.exports = __webpack_public_path__ + "img/companies.109c33d5.svg";